// extCustomColumns.actions.js
import * as actionTypes from './actionTypes';

export const setLoading = (payload) => ({
  type: actionTypes.SET_LOADING,
  payload,
});

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const setOpenDrawer = (payload) => ({
  type: actionTypes.SET_OPEN_DRAWER,
  payload
});

export const setExtCustomColumn = (payload) => ({
  type: actionTypes.SET_EXT_CUSTOM_COLUMN,
  payload
});

export const getExtCustomColumns = (params) => ({
  type: actionTypes.GET_EXT_CUSTOM_COLUMNS,
  params
});

export const getExtCustomColumn = (id) => ({
  type: actionTypes.GET_EXT_CUSTOM_COLUMN,
  id
});

export const createExtCustomColumn = (payload) => ({
  type: actionTypes.CREATE_EXT_CUSTOM_COLUMN,
  payload
});

export const updateExtCustomColumn = (payload) => ({
  type: actionTypes.UPDATE_EXT_CUSTOM_COLUMN,
  payload,
});

export const deleteExtCustomColumn = (Id) => ({
  type: actionTypes.DELETE_EXT_CUSTOM_COLUMN,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});

export const updateExtCustomColumnsOrder = (orderData) => ({
    type: actionTypes.UPDATE_EXT_CUSTOM_COLUMNS_ORDER,
    payload: { orderData }
});

export const attachExtCustomColumn = (Id) => ({
  type: actionTypes.ATTACH_EXT_CUSTOM_COLUMN,
  Id
});

export const detachExtCustomColumn = (Id) => ({
  type: actionTypes.DETACH_EXT_CUSTOM_COLUMN,
  Id
});

export const resetCustomColumnForm = () => ({
  type: actionTypes.RESET_CUSTOM_COLUMN_FORM,
});